import React, { useState } from "react";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import AgentReportMobileCard from "../agent-report/agentReportMobileCard";
import {
  convertStraight,
  convertThenFormat,
  currentDateOfTheMonth,
} from "../../common-data/Converts";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import FDTaskSop from "./FDTaskSop";

const TaskSop = ({ userInfoData, prevAllFilters }) => {
  const { AgentReportTaskSopData, loading } = useSelector((state) => state.api);

  const { selectedStartDate, selectedEndDate } = prevAllFilters || {};
  const startDate = selectedStartDate
    ? convertStraight(selectedStartDate)
    : "-";
  const endDate = selectedEndDate ? convertStraight(selectedEndDate) : "-";

  const iniClickValues = {
    isModOpen: false,
    rowData: "",
    cardName: "",
  };
  const [clickValues, setClickValues] = useState(iniClickValues);

  function onCloseModal() {
    setClickValues(iniClickValues);
  }

  const agentSopTbColumns = [
    {
      dataField: "gym_name",
      text: <p className="table__header">gym name</p>,
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text link"
            style={{
              textWrap: "wrap",
            }}
            onClick={() => {
              setClickValues({
                isModOpen: true,
                rowData: row,
                cardName: "fd-task-SOP",
              });
            }}
          >
            {row?.gym_name || "NA"}
          </p>
        );
      },
    },
    {
      dataField: "this_month_total_unpaid",
      text: (
        <p className="table__header">
          this month total unpaid ({startDate}/{endDate})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.this_month_total_unpaid ? row?.this_month_total_unpaid : 0}
          </p>
        );
      },
    },
    {
      dataField: "this_month_unpaid_added_to_lead",
      text: (
        <p className="table__header">
          this month unpaid added to lead ({startDate}/{endDate})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.this_month_unpaid_added_to_lead
              ? row?.this_month_unpaid_added_to_lead
              : 0}
          </p>
        );
      },
    },
    {
      dataField: "this_month_unpaid_today_followup",
      text: (
        <p className="table__header">
          this month unpaid today follow up (
          {convertStraight(currentDateOfTheMonth)})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.this_month_unpaid_today_followup
              ? row?.this_month_unpaid_today_followup
              : 0}
          </p>
        );
      },
    },
    {
      dataField: "sixty_days_total_unpaid",
      text: <p className="table__header">sixty days total unpaid</p>,
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.sixty_days_total_unpaid ? row?.sixty_days_total_unpaid : 0}
          </p>
        );
      },
    },
    {
      dataField: "sixty_days_unpaid_added_to_lead",
      text: <p className="table__header">sixty days unpaid added to lead</p>,
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.sixty_days_unpaid_added_to_lead
              ? row?.sixty_days_unpaid_added_to_lead
              : 0}
          </p>
        );
      },
    },
    {
      dataField: "sixty_days_unpaid_not_added_to_lead",
      text: (
        <p className="table__header">sixty days unpaid not added to lead</p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.sixty_days_unpaid_not_added_to_lead
              ? row?.sixty_days_unpaid_not_added_to_lead
              : 0}
          </p>
        );
      },
    },
    {
      dataField: "sixty_days_unpaid_today_followup",
      text: (
        <p className="table__header">
          sixty days unpaid today follow up (
          {convertStraight(currentDateOfTheMonth)})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.sixty_days_unpaid_today_followup
              ? row?.sixty_days_unpaid_today_followup
              : 0}
          </p>
        );
      },
    },
    {
      dataField: "this_month_missed_interested_followup",
      text: (
        <p className="table__header">
          this month missed interested follow up ({startDate}/{endDate})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.this_month_missed_interested_followup
              ? row?.this_month_missed_interested_followup
              : 0}
          </p>
        );
      },
    },
    {
      dataField: "today_followup_added",
      text: (
        <p className="table__header">
          today follow up added ({convertStraight(currentDateOfTheMonth)})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.today_followup_added ? row?.today_followup_added : 0}
          </p>
        );
      },
    },
    {
      dataField: "advancerenew_this_month",
      text: (
        <p className="table__header">
          advance renewel this month ({startDate}/{endDate})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.advancerenew_this_month ? row?.advancerenew_this_month : 0}
          </p>
        );
      },
    },
    {
      dataField: "advancerenew_today_followup",
      text: (
        <p className="table__header">
          advance renewel today follow up (
          {convertStraight(currentDateOfTheMonth)})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.advancerenew_today_followup
              ? row?.advancerenew_today_followup
              : 0}
          </p>
        );
      },
    },
    {
      dataField: "expt_today",
      text: (
        <p className="table__header">
          expiry today ({convertStraight(currentDateOfTheMonth)})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.expt_today ? row?.expt_today : 0}
          </p>
        );
      },
    },
    {
      dataField: "expt_today_followup",
      text: (
        <p className="table__header">
          expiry today follow up ({convertStraight(currentDateOfTheMonth)})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.expt_today_followup ? row?.expt_today_followup : 0}
          </p>
        );
      },
    },
    {
      dataField: "rawlead_assigned_today",
      text: (
        <p className="table__header">
          raw lead assigned today ({convertStraight(currentDateOfTheMonth)})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.rawlead_assigned_today ? row?.rawlead_assigned_today : 0}
          </p>
        );
      },
    },
    {
      dataField: "rawlead_assigned_today_followup",
      text: (
        <p className="table__header">
          raw lead assigned today follow up (
          {convertStraight(currentDateOfTheMonth)})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.rawlead_assigned_today_followup
              ? row?.rawlead_assigned_today_followup
              : 0}
          </p>
        );
      },
    },
    {
      dataField: "total_receptionist",
      text: <p className="table__header">total receptionist</p>,
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.total_receptionist ? row?.total_receptionist : 0}
          </p>
        );
      },
    },
    {
      dataField: "sales_target_today",
      text: (
        <p className="table__header">
          sales target today ({convertStraight(currentDateOfTheMonth)})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {`₹${convertThenFormat(row?.sales_target_today || 0)}`}
          </p>
        );
      },
    },
    {
      dataField: "sales_completed_today",
      text: (
        <p className="table__header">
          sales completed today ({convertStraight(currentDateOfTheMonth)})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.sales_completed_today
              ? `₹${convertThenFormat(row?.sales_completed_today)}`
              : 0}
          </p>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer`}>
          <ModalHeadAndClose
            title={`${clickValues.cardName?.replace(/-/g, " ")}`}
            onClose={onCloseModal}
          />

          <FDTaskSop
            userInfoData={userInfoData}
            prevAllFilters={prevAllFilters}
            rowData={clickValues.rowData}
          />
        </div>
      </Modal>

      {loading ? (
        <ReactVortoxSpinner />
      ) : (
        <>
          <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table">
            <PaymentLinkTable
              tableColumns={agentSopTbColumns}
              tableData={AgentReportTaskSopData?.data}
              isFirstColSticky={true}
            />
          </div>

          <div className="lead-logs-card-container only-mobile">
            <AgentReportMobileCard
              tableData={AgentReportTaskSopData?.data}
              type="agentsop"
              setClickValues={setClickValues}
            />
          </div>
        </>
      )}
    </>
  );
};

export default TaskSop;
